const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

    (binding.modules['herbal-adventureworks'] = {
        c: () => require('partner/themes/herbal-adventureworks/herbal-adventureworks.tsx'),
        $type: 'themeModule',
        da: [{name:'content',  path:'modules/herbal-product-specification/actions/get-cms-product-attribute.action', moduleName: 'buybox',runOn: 0}],
        definitionExtensions: ['active-image','b2b-requests-status','business-organization-list','buybox','cart-icon','cart','checkout-payment-instrument','content-block','header','herbal-cart','herbal-search-result-container','herbal-text-block-video','image-list','navigation-menu','order-template-list','promo-banner','ratings-histogram','reviews-list','search-result-container','search','store-selector','text-block','write-review'],
        iNM: false,
        ns: '__local__',
        n: 'herbal-adventureworks',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'herbal-adventureworks.theme.settings.json',
        md: 'src/themes/herbal-adventureworks'
    });
        

        {
            const sanitizedActionPath = 'modules/herbal-product-specification/actions/get-cms-product-attribute.action';
            let dataAction = require('partner/modules/herbal-product-specification/actions/get-cms-product-attribute.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };